module.exports = "/virtual-football-league/img/video/video-mega-jackpot.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/video/video-mega-jackpot.png
// module id = 362
// module chunks = 4